import React, {useCallback} from 'react';
import {useNavigate} from 'react-router';
import {Stack, Typography} from '@mui/material';
import TarotmailCustomerComp from '../../components/TarotmailCustomerComp.js';
import withMainContainer from '../../components/WithMainContainer.js';
import {withTitle} from '../../title.js';
import {obj2qs, SIMONA_USER_ID} from '../../util/util.js';
import {closeModal, openModal} from '../../components/Modals.js';
import SCButton from '../../components/SCButton.js';

const TarotmailDescription = ()=><Stack direction="column" gap={2}>
  <Typography>
    לפעמים כל מה שצריך כדי לשנות את כל היום - זה מסר אחד נכון בזמן הנכון.
  </Typography>
  <Typography>
    משפט שיזכיר לך מה באמת חשוב, או נקודת מבט שתפתח לך את הלב והמחשבה. החלטתי לתת לך בדיוק את זה - מתנה קטנה, אבל כזאת שיכולה לעשות שינוי גדול.
  </Typography>
  <Typography>
    קבלו ממני מסר אישי - כל יום, במשך שבוע
  </Typography>
  <Typography>
    בכל בוקר, למשך שבעה ימים, יחכה לך במייל <strong>מסר יומי מלא ומעמיק מהקלפים</strong> - שיפתח את המחשבה, יעודד, ויכוון אותך לדרך הנכונה.
  </Typography>
  <Typography>
    המסרים כוללים הכוונה כללית לאותו יום, וגם התמקדות מיוחדת לתחום הקריירה ולתחום האהבה. כל מסר נבחר בקפידה, כדי לתת לך זווית ראייה חדשה, להוסיף בהירות וביטחון, ולעזור לך לפתוח את היום באנרגיה טובה.<br/>
    ההרשמה חינם - פשוט ממלאים שם ומייל, ואני אשלח לך מתנה קטנה של השראה, מדי בוקר, במשך שבוע שלם.
  </Typography>
</Stack>;

const AddRoundModal = props=>{
    let {customerName, customerEmail} = props;
    let navigate = useNavigate();
    let onClick = useCallback(()=>{
        navigate('/tarotmail/simona/add_round?'+obj2qs(
            {firstName: customerName, email: customerEmail}));
        closeModal();
    }, [navigate, customerName, customerEmail]);
    return <Stack direction="column" gap={2}>
      <Typography>
        כבר השתמשת בסבב החינמי. ניתן לפתוח סבב נוסף ב-10₪ בלבד
      </Typography>
      <Stack>
        <SCButton variant="contained" text="פתיחת סבב נוסף"
          onClick={onClick}/>
      </Stack>
    </Stack>;
};

const TarotmailCustomerSimona = ()=>{
    let onCustomerNotEligible = useCallback((opt={})=>openModal({
        header: 'פתיחת סבב נוסף',
        content: <AddRoundModal {...opt}/>,
    }), []);
    return <TarotmailCustomerComp id={SIMONA_USER_ID} hideName
      description={<TarotmailDescription/>}
      onCustomerNotEligible={onCustomerNotEligible}/>;
};

export default withMainContainer(withTitle('מסר שבועי במייל', TarotmailCustomerSimona), {footerMargin: 4});
